module.exports = __webpack_public_path__ + "static/img/Permiso(10).82e1371.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(10).jpg
// module id = y9MU
// module chunks = 0